import { inject, Injectable, signal, computed } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, tap, finalize, shareReplay } from 'rxjs';
import { environment } from '../../../environments/environment';
import { Usuario } from '../models/usuario.models';

@Injectable({
  providedIn: 'root',
})
export class ProfileService {
  private apiUrl = `${environment.apiUrl}/conta`;
  private http = inject(HttpClient);
  private userSignal = signal<Usuario | null>(null);
  private profileRequest$: Observable<Usuario> | null = null;

  readonly currentUser = computed(() => this.userSignal());
  readonly loaded = computed(() => !!this.userSignal());

  getUserProfile(): Observable<Usuario> {
    if (this.profileRequest$) {
      return this.profileRequest$;
    }

    this.profileRequest$ = this.http.get<Usuario>(`${this.apiUrl}/perfil`).pipe(
      tap((user) => {
        this.userSignal.set(user);
      }),
      finalize(() => {
        this.profileRequest$ = null;
      }),
      shareReplay(1)
    );

    return this.profileRequest$;
  }

  clearProfile(): void {
    this.userSignal.set(null);
  }
}
